import React from 'react';
import CustomSelect from '../../ui/CustomSelect';

interface ModelSpecificationProps {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function ModelSpecification({
  formData,
  handleChange,
  errors = {},
}: ModelSpecificationProps) {
  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Spesifikasi Model</h3>
        <p className="text-sm text-gray-500">Informasi dasar model scoring</p>
      </div>
      <div className="p-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Judul Model <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.title}
            onChange={e => handleChange('title', e.target.value)}
            placeholder="Contoh: Model Scoring KPR Wirausaha"
            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200 ${
              errors.title ? 'border-red-500' : 'border-gray-300'
            }`}
            required
          />
          {errors.title && <p className="text-sm text-red-600 mt-1">{errors.title}</p>}
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={formData.status}
              onChange={v => handleChange('status', v)}
              placeholder="Pilih status"
              width="w-full"
              error={!!errors.status}
              options={[
                { value: 'draft', label: 'Draft' },
                { value: 'active', label: 'Aktif' },
                { value: 'inactive', label: 'Nonaktif' },
              ]}
            />
            {errors.status && <p className="text-sm text-red-600 mt-1">{errors.status}</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Jenis Kredit <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={formData.credit_type}
              onChange={v => handleChange('credit_type', v)}
              placeholder="Pilih jenis"
              width="w-full"
              error={!!errors.credit_type}
              options={[
                { value: 'working_capital', label: 'Modal Kerja' },
                { value: 'investment', label: 'Investasi' },
                { value: 'consumer', label: 'Konsumtif' },
                { value: 'kpr', label: 'KPR' },
                { value: 'kendaraan', label: 'Kendaraan' },
                { value: 'multiguna', label: 'Multiguna' },
              ]}
            />
            {errors.credit_type && (
              <p className="text-sm text-red-600 mt-1">{errors.credit_type}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Jenis Debitur <span className="text-red-500">*</span>
            </label>
            <CustomSelect
              value={formData.debtor_type}
              onChange={v => handleChange('debtor_type', v)}
              placeholder="Pilih jenis"
              width="w-full"
              error={!!errors.debtor_type}
              options={[
                { value: 'individual', label: 'Perorangan' },
                { value: 'corporate', label: 'Badan Usaha' },
              ]}
            />
            {errors.debtor_type && (
              <p className="text-sm text-red-600 mt-1">{errors.debtor_type}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Apakah Wirausaha?
            </label>
            <div className="flex items-center h-10 gap-3">
              <button
                type="button"
                onClick={() => handleChange('is_entrepreneur', !formData.is_entrepreneur)}
                className={`relative w-12 h-6 rounded-full transition-colors duration-200 ${
                  formData.is_entrepreneur ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
                    formData.is_entrepreneur ? 'translate-x-6' : 'translate-x-0'
                  }`}
                />
              </button>
              <span className="text-sm">{formData.is_entrepreneur ? 'Ya' : 'Tidak'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
